import React, { Component } from 'react';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy';
import { BasicModal } from '../common/modals/BasicModal';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import { AccountsList } from './AccountsList';
import config from '../../config';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import StringConstants from '../../constants/StringConstants';

class AccountsModal extends Component {
  constructor(props) {
    super(props);

    this.getAccountIdOnToggle = this.getAccountIdOnToggle.bind(this);
    this.onOkClick = this.onOkClick.bind(this);

    this.state = {
      isButtonDisabled: false,
      accountNumbers: props.getAllAccountIds,
    };
  }

  getAccountIdOnToggle(e) {
    const accountNumbers = this.state.accountNumbers;
    if (e.target.checked) {
      accountNumbers.push(e.target.getAttribute('data-id'));
    } else {
      for (const i in accountNumbers) {
        if (accountNumbers[i] === e.target.getAttribute('data-id')) {
          accountNumbers.splice(i, 1);
          break;
        }
      }
    }

    this.setState({
      isButtonDisabled: accountNumbers.length === 0,
      accountNumbers,
    });
  }

  onOkClick() {
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_action_spend_filter_by_account,
        event: 'click',
      }
    );
    SpendingsActionCreator.getSpendListConnection(this.state.accountNumbers);
  }

  render() {
    const { content, getAllAccountIds, spendingAccountList, onHide } =
      this.props;

    return (
      <BasicModal keyboard={false} backdrop="static">
        <div className="toggle_content">
          <h3>Accounts</h3>
          <ul className="account-list">
            {sortBy(spendingAccountList, ['display_order']).map((account, i) =>
              account.product.code !== StringConstants.KAPITI_PRODUCT_CODE &&
              account.actions_available['/account/transactions/read'] ? (
                <AccountsList
                  accNumbers={getAllAccountIds}
                  colorIndex={(i % 10) + 1}
                  key={i}
                  dataKey={i}
                  account={account}
                  getAccountID={this.getAccountIdOnToggle}
                />
              ) : null
            )}
          </ul>
        </div>
        <div className="toggle_footer">
          <button onClick={onHide}>{content.spendingCancelButtonText}</button>
          <button
            disabled={this.state.isButtonDisabled}
            onClick={this.onOkClick}
          >
            {content.spendingOkButtonText}
          </button>
        </div>
      </BasicModal>
    );
  }
}

AccountsModal.propTypes = {
  onHide: PropTypes.func,
  content: PropTypes.object,
  spendingAccountList: PropTypes.array,
  getAllAccountIds: PropTypes.array,
};

export { AccountsModal };
